/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4Variants interface.
 */
export function instanceOfInternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4Variants(value) {
    if (!('_default' in value) || value['_default'] === undefined)
        return false;
    if (!('light' in value) || value['light'] === undefined)
        return false;
    if (!('mediumLight' in value) || value['mediumLight'] === undefined)
        return false;
    if (!('medium' in value) || value['medium'] === undefined)
        return false;
    if (!('mediumDark' in value) || value['mediumDark'] === undefined)
        return false;
    if (!('dark' in value) || value['dark'] === undefined)
        return false;
    return true;
}
export function InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsFromJSON(json) {
    return InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsFromJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        '_default': json['default'],
        'light': json['light'],
        'mediumLight': json['medium_light'],
        'medium': json['medium'],
        'mediumDark': json['medium_dark'],
        'dark': json['dark'],
    };
}
export function InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsToJSON(json) {
    return InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsToJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionEmojiDefinitionBaseV4VariantsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'default': value['_default'],
        'light': value['light'],
        'medium_light': value['mediumLight'],
        'medium': value['medium'],
        'medium_dark': value['mediumDark'],
        'dark': value['dark'],
    };
}
